"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNDERWRITING_METHODOLOGIES = exports.POST_UNDERWRITE_STATUSES = exports.PRE_AGREEMENT_STATUSES = exports.RENTAL_APPLICATION_STATUSES = exports.RENTAL_APPLICATION_CANCELATION_SUBREASONS = exports.RENTAL_APPLICATION_CANCELATION_REASONS = exports.QUALIFICATION_FLAGS = void 0;
exports.QUALIFICATION_FLAGS = {
    CRIMINAL_HISTORY: 'criminal_history',
    EVICTION_HISTORY: 'eviction_history',
    ALERTS_HISTORY: 'alerts_found',
    CRIMINAL_REPORT_OUTDATED: 'criminal_report_outdated',
    EVICTION_REPORT_OUTDATED: 'eviction_report_outdated',
    ALERTS_OUTDATED: 'alerts_outdated',
    CRIMINAL_REPORT_NOT_AVAILABLE: 'criminal_report_not_available',
    EVICTION_REPORT_NOT_AVAILABLE: 'eviction_report_not_available',
    ALERTS_NOT_AVAILABLE: 'alerts_not_available'
};
exports.RENTAL_APPLICATION_CANCELATION_REASONS = Object.freeze({
    CREDIT_REPORT: 'credit_report',
    INCOME: 'income',
    BACKGROUND_CHECK: 'background_check',
    DOCUMENTS_REJECTED: 'documents_rejected',
    HOME_RENTED: 'home_rented',
    TENANT_REASON: 'tenant_reason',
    ENGINEERING: 'engineering'
});
exports.RENTAL_APPLICATION_CANCELATION_SUBREASONS = Object.freeze({
    credit_report: {
        INSUFFICIENT: 'insufficient',
        DEBT_TO_INCOME_RATIO: 'debt_to_income_ratio',
        INFILE_DATE: 'infile_date',
        NO_CREDIT: 'no_credit',
        ADVERSE_RENTAL_HISTORY: 'adverse_rental_history',
        RECENT_BANKRUPTCY: 'recent_bankruptcy'
    },
    income: {
        INSUFFICIENT: 'insufficient'
    },
    background_check: {
        CRIMINAL_HISTORY: 'criminal_history',
        EVICTION_HISTORY: 'eviction_history'
    },
    documents_rejected: {
        OFFER_LETTER: 'offer_letter',
        TAX_RETURN: 'tax_return',
        PAYSTUB: 'paystub',
        BANK_STATEMENTS: 'bank_statements',
        ID: 'id'
    },
    home_rented: {
        REMATCHED: 'rematched',
        NO_REMATCH: 'no_rematch'
    },
    tenant_reason: {
        FOUND_ANOTHER_HOME: 'found_another_home',
        CANNOT_AFFORD_MOVE_IN_COST: 'cannot_afford_move_in_cost',
        MOVE_IN_TIMELINE: 'move_in_timeline',
        LEASE_TERM: 'lease_term',
        NOT_INTERESTED_IN_PROGRAM_TERMS: 'not_interested_in_program_terms',
        DID_NOT_PAY_APP_FEE: 'did_not_pay_app_fee',
        UNRESPONSIVE: 'unresponsive'
    },
    engineering: {
        DUPLICATE_APPLICATION: 'duplicate_application',
        TEST: 'test'
    }
});
exports.RENTAL_APPLICATION_STATUSES = Object.freeze({
    PENDING_ADDITIONAL_UNDERWRITING_INFORMATION: 'pending_additional_underwriting_information',
    PENDING_CUSTOMER_INFORMATION: 'pending_customer_information',
    PENDING_APPLICATION_FEE_PAYMENT: 'pending_application_fee_payment',
    PENDING_APPLICATION_REVIEW: 'pending_application_review',
    PENDING_UNDERWRITING: 'pending_underwriting',
    PENDING_INITIAL_UNDERWRITING_REQUEST: 'pending_initial_underwriting_request', // saferent
    PENDING_INITIAL_UNDERWRITING: 'pending_initial_underwriting', // saferent
    PENDING_FINAL_UNDERWRITING_REQUEST: 'pending_final_underwriting_request', // saferent
    PENDING_FINAL_UNDERWRITING: 'pending_final_underwriting', // saferent
    PENDING_ADDITIONAL_LEASE_INFORMATION: 'pending_additional_lease_information',
    HOLD_FOR_NEW_LEASE: 'hold_for_new_lease',
    PENDING_RENTAL_AGREEMENT_CREATION: 'pending_rental_agreement_creation',
    PENDING_CUSTOMER_RENTAL_AGREEMENT_COMPLETION: 'pending_customer_rental_agreement_completion',
    PENDING_CUSTOMER_PAYMENT: 'pending_customer_payment',
    PENDING_UP_AND_UP_RENTAL_AGREEMENT_COMPLETION: 'pending_upandup_rental_agreement_completion',
    PENDING_PROPERTY_PURCHASE: 'pending_property_purchase',
    COMPLETE: 'complete',
    CANCELED: 'canceled'
});
const { PENDING_CUSTOMER_INFORMATION, PENDING_APPLICATION_FEE_PAYMENT, PENDING_APPLICATION_REVIEW, PENDING_UNDERWRITING, PENDING_ADDITIONAL_UNDERWRITING_INFORMATION, PENDING_RENTAL_AGREEMENT_CREATION, PENDING_CUSTOMER_RENTAL_AGREEMENT_COMPLETION, PENDING_UP_AND_UP_RENTAL_AGREEMENT_COMPLETION, PENDING_CUSTOMER_PAYMENT, PENDING_PROPERTY_PURCHASE, PENDING_ADDITIONAL_LEASE_INFORMATION, COMPLETE, CANCELED } = exports.RENTAL_APPLICATION_STATUSES;
exports.PRE_AGREEMENT_STATUSES = [
    PENDING_CUSTOMER_INFORMATION,
    PENDING_APPLICATION_FEE_PAYMENT,
    PENDING_APPLICATION_REVIEW,
    PENDING_UNDERWRITING,
    PENDING_ADDITIONAL_UNDERWRITING_INFORMATION,
    PENDING_RENTAL_AGREEMENT_CREATION,
    PENDING_ADDITIONAL_LEASE_INFORMATION
];
// all other statuses are considered post underwrite
exports.POST_UNDERWRITE_STATUSES = [
    PENDING_CUSTOMER_RENTAL_AGREEMENT_COMPLETION,
    PENDING_UP_AND_UP_RENTAL_AGREEMENT_COMPLETION,
    PENDING_CUSTOMER_PAYMENT,
    PENDING_PROPERTY_PURCHASE,
    COMPLETE,
    CANCELED
];
exports.UNDERWRITING_METHODOLOGIES = {
    UPANDUP: 'upandup',
    SAFERENT: 'saferent'
};
